export default __webpack_public_path__ + "images/2K.8f36973.png";